/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import AuthService from '../../../services/login/auth.service';
import Error404 from "../../pages/error404";
import ConfigService from "../../../services/configuracion/ConfigService";
import DatosSocio from "../../generico/DatosSocio";
import { componentes } from "../../generico/utils/Componentes";
import authService from "../../../services/login/auth.service";
import ExtractoPanalCabal from "../../pages/consulta/ExtractoPanalCabal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faUser, faMessage, faRightFromBracket, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import DarkMode from "../../DarkMode";
import { trackPromise } from 'react-promise-tracker';
import { toast, ToastContainer } from 'react-toastify';
import Popup from "react-popup";
function logOut() {
  //alert("cierra")
  AuthService.logout();
}

const RESUMEN_GENERAL_SOCIO = 0;
const MENU_DATOS_SOCIO = 79;
const muestraEntrust = false;
const muestraOtp = false;

const MenuLink = ({ to, className, children }) => {
  let path = ConfigService.getPathByName(to);
  return (
    path &&
    <Link to={path.url} className={className}>
      {children}
    </Link>
  )
}

const NavLink = ({ idMenu, className, dataToggle, href, children }) => {
  let acceso = ConfigService.getAccesoById(idMenu);
  return (
    acceso &&
    <a className={className} data-toggle={dataToggle} href={href}>
      {children}
    </a>
  )
}

function obtenerNombreApellido() {
  var usuario = AuthService.getCurrentUser();
  if (usuario !== null && usuario !== undefined && usuario !== "") {
    try {
      var array = usuario.nombreCompleto.split(",");
      var primerNombre = array[1].trim().split(" ")[0]
      var primerApellido = array[0].trim().split(" ")[0]
    } catch (error) {
      return "Administración";
    }
    return primerNombre + " " + primerApellido;
  }

  return "Administración";

}

function Menu3({ menu }) {
  return (
    menu.map((menu3, index) => (
      menu3.children === null
        ?
        <li key={index}>
          <Link to={menu3.path === null ? "#" : menu3.path}><i className="fa fa-angle-right"></i> {menu3.label}</Link>
        </li>
        :
        null
    ))
  )
}

function Menu2({ menu }) {
  return (
    menu.map((menu2, index) => (

      menu2.children !== null
        ?
        <div key={index} className="col-lg-3">
          <div className="col-megamenu">
            <h6 className="title">{menu2.label}</h6>
            <ul className="list-unstyled">
              <Menu3 menu={menu2.children} />
            </ul>
          </div>
        </div>
        :
        null

    ))
  )
}

function verificaTienePin() {
  let accesos = ConfigService.getAccesos();
 
    AuthService.debeCambiarPinTransaccional().then((response) => {
      var data = JSON.parse(response);
     
     //var jData = JSON.parse(jData).estadoPin);
     console.log("valores de pin",data.estadoPin)
      if(data.estadoPin === "I" && accesos[3].label === 'Autogestión'){
        console.log("entro auq", accesos[3].children[1])
        //accesos[3].children[1].children.splice(1,2)
        
         accesos[3].children.splice(1,1)
      }
    
    })
  
}


function Menu1() {

  let accesos = ConfigService.getAccesos();
  let estadoPin = sessionStorage.getItem('estadoPinTransaccional');
  const tokenActivo = sessionStorage.getItem('tieneToken');
  if( tokenActivo === 'N' ){
    let menuConsultas = accesos[4]?.children[0];
    if(menuConsultas?.children[4]?.label === 'Perfil-transaccional'){
      menuConsultas.children.pop();
    }
  }

  if( (tokenActivo === 'S' && estadoPin === 'I' && accesos[3].label === 'Autogestión') || (tokenActivo === 'N' && accesos[3].label === 'Autogestión') ){
    let autoChildren = accesos[3];
    if( autoChildren?.children[1]?.label === 'Interbancarias' ){
      autoChildren?.children[1]?.children?.splice(0,2);
    }
  }



 

  return (

    accesos
      ?
      accesos.map((menu1, index) => (

        (menu1.children) === null || menu1.id === RESUMEN_GENERAL_SOCIO
          ? menu1.path !== null
            ? <li key={index} className="nav-item">
              <Link className="nav-link menu-link" to={menu1.path}>{menu1.label}</Link>
            </li>
            : null
          : menu1.id === RESUMEN_GENERAL_SOCIO
            ? null
            : <li key={index} className="nav-item dropdown has-megamenu">
              <a className="nav-link menu-link dropdown-toggle" href="#" data-toggle="dropdown"> {menu1.label}</a>
              <div className="dropdown-menu megamenu megamenu-ubicacion" role="menu">
                <div className="row">
                  <Menu2 menu={menu1.children} />
                </div>
              </div>
            </li>
      ))
      : null
  )

}


 
export default function MegaMenu(props) {

  var usuario = AuthService.getCurrentUser()
  
  return (

    <Router>
      <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
      <nav className="main-header navbar navbar-expand-md navbar-light navbar-green" style={{ borderBottom: "none" }}>
        <div className="container">
          <a className="navbar-brand" href="#">
            <img src="dist/img/logo_nuevo_blanco.png" alt="Universitaria LTDA." className="menu-titulo-imagen" />
          </a>
          <button className="navbar-toggler" type="button" style={{ background: 'white', marginLeft: 70 }} data-toggle="collapse" data-target="#main_nav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <a href="#" onClick={() => logOut()} style={{ fontSize: 30 }} className="logout-responsive">
            <i className="fas fa-sign-out-alt mr-2" style={{ color: "white" }} />
          </a>
          <div className="collapse navbar-collapse"
            ref={element => { if (element) element.style.setProperty('display', props.visualizar, 'important'); }}
            id="main_nav">

            {/* inicio de menu */}
            <ul className="navbar-nav">
           
                <Menu1 />
            
              
            </ul >
            {/* fin menu */}

            <ul className="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto">
              <li className="nav-item dropdown user-menu">
                <NavLink idMenu={MENU_DATOS_SOCIO} className="nav-link menu-link dropdown-toggle" dataToggle="dropdown" href="#">
                <div className="drop-mmenus">
                <FontAwesomeIcon icon={faUserAlt} /> <i className="fas fa-caret-down"></i>
                </div>
                <div className="drop-mmenu-name">
                {obtenerNombreApellido()} <i className="fas fa-caret-down"></i>
                </div>
                 
                </NavLink>
                <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-left">
                  {/* User image */}
                  <li className="user-header bg-success-cu-secondary menuDropdown" style={{ height: "auto" }}>
                    <DatosSocio />
                    <small className="acceso">Último acceso el {usuario.ultimoAcceso}</small>
                  </li>
                  <li className="user-body" style={{ borderBottom: "1px solid #ced4da" }}>
                    <MenuLink to="cambioClave" className="dropdown-item">
                      <FontAwesomeIcon icon={faLock} className="icondopdown" /> <label className="textodrop"> Cambiar Clave </label>
                    </MenuLink>
                    <div className="dropdown-divider" />
                    <MenuLink to="datosPersonales" className="dropdown-item">
                      <FontAwesomeIcon icon={faUser} className="icondopdown" /> <label className="textodrop"> Datos Personales </label>
                    </MenuLink>
                    <div className="dropdown-divider" />
                    <MenuLink to="sugerencias" className="dropdown-item">
                      <FontAwesomeIcon icon={faMessage} className="icondopdown" /> <label className="textodrop"> Sugerencias</label>
                    </MenuLink>
                    <div className="dropdown-divider" />
                    <li className="dropdown-item">
                    <div className="row">
                      <div className="col-md-3" style={{display:"grid", alignItems:"center"}}><label className="textodrop"> Tema</label></div>
                      <div className="col-md-9"><DarkMode/></div>
                    </div>
                      
                  </li>

                    
                      
                    
                  </li>

                  <li className="user-footer">
                    <a href="#" className=" btn-default btn-block btn-flat float-right btnclose" onClick={() => logOut()}>
                      <FontAwesomeIcon icon={faRightFromBracket} className="icondopclose" /> <span className="textclose"> Cerrar Sesión </span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div >
          
        </div >
      </nav >
      
      <Switch>

        {/*********************** INDEX ***********************/}
        {/* <Route exact path={["/", ConfigService.getPathByName("resumenGeneralSocio")?.url]}>
          {componentes["resumenGeneralSocio"]}
        </Route> */}

        <Route exact path={"/home"}>
          <div style={{ position: "relative", height: "84vh" }}></div>
        </Route>

        <Route path={"/extractoPanalCabal"}>
          <ExtractoPanalCabal />
        </Route>

        {/**
         * crear rutas segun tenga habilitado
         */}
        {
          ConfigService.getPaths()?.map((path, index) => {
            return (
              <Route key={index} path={path.url}>
                {componentes[path.nombre]}
              </Route>
            );
          })
        }

        {/*********************** USUARIO ***********************/}
        <Route path={ConfigService.getPathByName("datosPersonales")?.url}>
          {componentes["datosPersonales"]}
        </Route>
        <Route path={ConfigService.getPathByName("cambioClave")?.url}>
          {componentes["cambioClave"]}
        </Route>
        <Route path={ConfigService.getPathByName("sugerencias")?.url}>
          {componentes["sugerencias"]}
        </Route>
        {/************************PAGINA DE ERRORES***********************/}
        <Route component={() => <Error404 logueado="SI" />} />

      </Switch>
    </Router >

  );
}